import { ResourceCentrePageCategoryItem } from '../../../types';

export const translations: ResourceCentrePageCategoryItem = {
  title: 'Cartes de fidélité',
  content: [
    'Dans la plupart des cas, les cartes de fidélité comme Récompenses Bleu, Aéroplan, la carte ',
    'PC Optimum et la carte « argent » de Canadian Tire peuvent être remplacées en contactant',
    'l’émetteur. Il est conseillé d’avertir rapidement le programme pour vous éviter toute',
    'activité non autorisée. Consultez les sites Web respectifs de chaque émetteur pour connaître',
    'les différents numéros de téléphone.'
  ].join('\n')
};
